import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import ManageAgencyProviderPackageModal from '@modals/ManageAgencyProviderPackageModal'

import { AgencyProviderPackageModel } from '@models/types'

import PageContent from './components/PageContent'

const defaultState = {
  showManageAgencyProviderPackageModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    ManageAgencyProviderPackageModal: {
      closeModal: () => setState({ showManageAgencyProviderPackageModal: false }),
      updateAgencyProviderPackage: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showManageAgencyProviderPackageModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showManageAgencyProviderPackageModal: (payload: { agencyProviderPackage: AgencyProviderPackageModel }) => {
        setModalData('ManageAgencyProviderPackageModal', payload)
        setState({ showManageAgencyProviderPackageModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <ManageAgencyProviderPackageModal
          callbacks={callbacks('ManageAgencyProviderPackageModal', setState)}
          showModal={showManageAgencyProviderPackageModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}
export default List
